import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import LoanPaymentList from './LoanPaymentList';

const LoanPayment = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Pagos' pageTitle='Prestamos' />
                <LoanPaymentList />
            </div>
        </React.Fragment>
    )
}

export default LoanPayment;